export default __webpack_public_path__ + "static/media/RectangleLeft.648a6555.png";